import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import { getDisabledRoutesForPhoenixAccount } from '../../../../helper/phoenixHelper';

const reports = (accountId, options) => {
  const { isPhoenix, isSuperAdmin } = options;

  const config = {
    parentNav: 'reports',
    routes: [
      'account_overview_reports',
      'conversation_reports',
      'csat_reports',
      'bot_reports',
      'agent_reports',
      'label_reports',
      'inbox_reports',
      'team_reports',
      'sent_templates_reports',
      'sla_reports',
    ],
    menuItems: [
      {
        icon: 'arrow-trending-lines',
        label: 'SIDEBAR.REPORTS_OVERVIEW',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/overview`),
        toStateName: 'account_overview_reports',
      },
      {
        icon: 'chat',
        label: 'SIDEBAR.REPORTS_CONVERSATION',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/conversation`),
        toStateName: 'conversation_reports',
      },
      {
        icon: 'emoji',
        label: 'SIDEBAR.CSAT',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/csat`),
        toStateName: 'csat_reports',
      },
      {
        icon: 'bot',
        label: 'SIDEBAR.REPORTS_BOT',
        hasSubMenu: false,
        featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
        toState: frontendURL(`accounts/${accountId}/reports/bot`),
        toStateName: 'bot_reports',
      },
      {
        icon: 'people',
        label: 'SIDEBAR.REPORTS_AGENT',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/agent`),
        toStateName: 'agent_reports',
      },
      {
        icon: 'tag',
        label: 'SIDEBAR.REPORTS_LABEL',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/label`),
        toStateName: 'label_reports',
      },
      {
        icon: 'mail-inbox-all',
        label: 'SIDEBAR.REPORTS_INBOX',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
        toStateName: 'inbox_reports',
      },
      {
        icon: 'people-team',
        label: 'SIDEBAR.REPORTS_TEAM',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/teams`),
        toStateName: 'team_reports',
      },
      {
        icon: 'send',
        label: 'CHATLYN_SENT_TEMPLATES_REPORTS.TITLE',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/reports/sent-templates`),
        toStateName: 'sent_templates_reports',
      },
    ],
  };

  if (isPhoenix) {
    const disabledRoutes = getDisabledRoutesForPhoenixAccount(isSuperAdmin);
    config.menuItems = config.menuItems.filter(
      item => !disabledRoutes.includes(item.toStateName)
    );
    config.routes = config.routes.filter(
      route => !disabledRoutes.includes(route)
    );
  }

  return config;
};

export default reports;
